import Centers from ".";

export const centerRoutes = [
  {
    path: "/centers",
    element: <Centers />,
  },
];
